module.exports = "#version 300 es\nprecision highp float;\n\nuniform vec3 u_Eye, u_Ref, u_Up;\nuniform vec2 u_Dimensions;\nuniform float u_Time;\n\nin vec2 fs_Pos;\nout vec4 out_Col;\n\nvoid main() {\n  // out_Col = vec4(0.5 * (fs_Pos + vec2(1.0)), 0.0, 1.0);\n  // vec2 newPos = 0.5 * (fs_Pos + vec2(1.0));\n  out_Col = mix( vec4(.7, .8, .6, 1), vec4(1.2, 1, .1, 1), fs_Pos.y);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-frag.glsl
// module id = 80
// module chunks = 0